var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '66', height: '65', viewBox: '0 0 66 65', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement(
      'g',
      { fillRule: 'evenodd' },
      React.createElement('path', { stroke: '#F2F2F2', d: 'M35.683 4.367L62.83 58.658A3 3 0 0160.146 63H5.854a3 3 0 01-2.683-4.342L30.317 4.367a3 3 0 015.366 0z', strokeWidth: '4', role: 'presentation' }),
      React.createElement(
        'g',
        { fill: '#F2F2F2', transform: 'translate(31 24)' },
        React.createElement('rect', { width: '4', height: '20', rx: '2', role: 'presentation' }),
        React.createElement('path', { d: 'M2 23a2 2 0 110 4 2 2 0 010-4z', role: 'presentation' })
      )
    )
  );
}

module.exports = function triangleExclamationMark(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};